"use client";

import React from "react";
import s from "../styles";

/**
 * 社内用備考コンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Object} props.form - フォームオブジェクト
 * @param {Object} props.formProps - フォームプロパティ
 * @param {string} props.mode - "view"（参照モード）または"edit"（編集モード）
 
 * @returns {JSX.Element} 社内用備考コンポーネント
 */
export default function RemarkNoteArea({ form, formProps, mode = "edit" }) {
  const isViewMode = mode === "view";

  const bikouValue = form?.BikouYZ || "";
  // 参照モードの場合
  if (isViewMode) {
    return (
      <s.RemarkNoteTable>
        <tbody>
          <tr>
            <s.OrderInfoRight width="200" scope="row" style={{ backgroundColor: "#FFF666" }}>
              社内用備考
              <br />
              <s.SmallFont>(お客様への表示は行われません)</s.SmallFont>
            </s.OrderInfoRight>
            <s.OrderInfoNote scope="row" style={{ backgroundColor: "#FFF666" }}>
              <div style={{ width: "100%", whiteSpace: "pre-line" }}>{bikouValue}</div>
            </s.OrderInfoNote>
          </tr>
        </tbody>
      </s.RemarkNoteTable>
    );
  }

  // 編集モードの場合

  return (
    <s.RemarkNoteTable>
      <tbody>
        <tr>
          <s.OrderInfoRight width="200" scope="row" style={{ backgroundColor: "#FFF666" }}>
            社内用備考
            <br />
            <s.SmallFont>(お客様への表示は行われません)</s.SmallFont>
          </s.OrderInfoRight>
          <s.OrderInfoNote scope="row" style={{ backgroundColor: "#FFF666" }}>
            {formProps.input_BikouYZ({ style: { width: "100%" } })}
          </s.OrderInfoNote>
        </tr>
      </tbody>
    </s.RemarkNoteTable>
  );
}
